/* istanbul ignore next */
export const getLocaleString = (price, isFraction) => {
    if (price) {
        const values = (isFraction ? parseFloat(price).toFixed(2) : parseFloat(price))
            .toString()
            .split('.');
        return (
            values[0].replace(/.(?=(?:.{3})+$)/g, '$&,') +
            (values.length === 2 ? `.${values[1]}` : '')
        );
    }
    return '0';
};

/* istanbul ignore next */
const AddPriceWithCommas = (price) => {
    if (typeof price === 'string') {
        price = isNaN(price) ? 0 : price;
        price = parseFloat(price);
    }
    // adding zero if decimal point is 1 (ex: 12.2 = 12.20)
    if (parseInt(price, 10) !== price) {
        return getLocaleString(price, true);
    }
    return getLocaleString(price);
};

/* istanbul ignore next */
const getPriceFormat = (min, max, isCurrency) => {
    let priceMatch;
    const dollarSymbol = '$';
    const percentageOff = '% off';
    if (min === 0 && min === max) {
        return '';
    }
    if (isCurrency) {
        priceMatch =
            min === max
                ? `${dollarSymbol}${AddPriceWithCommas(max)}`
                : `${dollarSymbol}${AddPriceWithCommas(min)} - ${dollarSymbol}${AddPriceWithCommas(
                      max
                  )}`;
    } else {
        priceMatch =
            min === max
                ? `${min}${percentageOff}`
                : `${AddPriceWithCommas(min)} - ${AddPriceWithCommas(max)}${percentageOff}`;
    }
    return priceMatch;
};

/* istanbul ignore next */
const getPrice = (prices) => {
    if (!prices) {
        return {
            showNoPriceLabel: true,
        };
    }

    const originalPrice = prices.amounts.filter(
        (amount) => amount.type.toUpperCase() === 'ORIGINAL'
    )[0];
    const defaultPrice = prices.amounts.filter(
        (amount) => amount.type.toUpperCase() !== 'ORIGINAL'
    )[0];
    let defaults = null;
    let defaultsPriceValue = null;
    let isDefaultsPriceRange = false;
    let type = null;
    let percentOff = null;
    let original = '';
    let originalPriceValue = null;
    let isOriginalPriceRange = false;
    let originalType = '';
    let dashed = '';
    let originalPriceMin = (originalPrice && originalPrice.min) || 0;
    let originalPriceMax = (originalPrice && originalPrice.max) || 0;
    let mapPrice = false;
    let currentMin;
    let currentMax;
    let originalPriceLabel;
    let currentPriceLabel;
    let showNoPriceLabel = false;
    const { eachLabel = '' } = prices;
    const promotions =
        prices.promotions && (prices.promotions[0] || {}).message
            ? prices.promotions[0].message
            : '';
    const marketingLabel = prices.marketingLabel ? prices.marketingLabel : '';
    if (!prices.manufacturerAdvertised && defaultPrice !== undefined) {
        let defaultPriceMin = defaultPrice.min;
        let defaultPriceMax = defaultPrice.max;

        if (!Number.isInteger(defaultPriceMin) || !Number.isInteger(defaultPriceMax)) {
            defaultPriceMin = defaultPriceMin.toFixed(2);
            defaultPriceMax = defaultPriceMax.toFixed(2);
        }

        if (!Number.isInteger(originalPriceMin) || !Number.isInteger(originalPriceMax)) {
            originalPriceMin = originalPriceMin.toFixed(2);
            originalPriceMax = originalPriceMax.toFixed(2);
        }
        defaults = getPriceFormat(defaultPriceMin, defaultPriceMax, true);
        isDefaultsPriceRange = defaultPriceMin !== defaultPriceMax;
        defaultsPriceValue = defaultPriceMin;
        type = defaultPrice.type.toUpperCase() !== 'DEFAULT' ? defaultPrice.type.toLowerCase() : '';
        percentOff =
            defaultPrice.minPercentOff > 0
                ? getPriceFormat(defaultPrice.minPercentOff, defaultPrice.maxPercentOff, false)
                : '';
        /* istanbul ignore next */
        if (originalPrice !== undefined && type) {
            original = getPriceFormat(originalPriceMin, originalPriceMax, true);
            originalPriceValue = originalPriceMin;
            isOriginalPriceRange = originalPriceMin !== originalPriceMax;
            originalType = 'was';
            if (defaultPrice.minPercentOff > 0) {
                dashed = ' | ';
            }
        }
    } else {
        if (!Number.isInteger(originalPriceMin) || !Number.isInteger(originalPriceMax)) {
            originalPriceMin = originalPriceMin.toFixed(2);
            originalPriceMax = originalPriceMax.toFixed(2);
        }
        defaults = getPriceFormat(originalPriceMin, originalPriceMax, true);
        isDefaultsPriceRange = originalPriceMin !== originalPriceMax;
        defaultsPriceValue = originalPriceMin;
        if (prices.manufacturerAdvertised) {
            mapPrice = true;
            if (originalPrice !== undefined) {
                original = getPriceFormat(originalPriceMin, originalPriceMax, true);
                isOriginalPriceRange = originalPriceMin !== originalPriceMax;
                originalPriceValue = originalPriceMin;
                originalType = original !== '' ? 'was' : '';
                defaults = null;
            }
        }
    }

    /**
     * If original and offer price both are same, we will show only one price
     */
    /* istanbul ignore next */
    if (defaults === original) {
        original = '';
        originalType = '';
        isOriginalPriceRange = false;
        originalPriceValue = null;
        dashed = '';
        type = '';
    }

    // /* istanbul ignore next */
    if (!defaults && !original) {
        showNoPriceLabel = true;
    }

    if (defaultPrice !== undefined) {
        currentMin = defaultPrice.min || 0;
        currentMax = defaultPrice.max || 0;
        currentPriceLabel = defaultPrice.type || '';
    }

    if (originalPrice !== undefined) {
        originalPriceLabel = originalPrice.type || '';
    }

    const price = {
        defaults,
        original,
        originalType,
        percentOff,
        type,
        isDefaultsPriceRange,
        isOriginalPriceRange,
        defaultsPriceValue,
        originalPriceValue,
        marketingLabel,
        promotions,
        dashed,
        mapPrice,
        currentMin,
        currentMax,
        originalPriceLabel,
        currentPriceLabel,
        showNoPriceLabel,
        eachLabel,
    };

    if (prices.fpac) {
        const fprice = prices.fpac;
        let { fpacPriceMin } = fprice;
        let { fpacPriceMax } = fprice;

        // converting the float to fixed length of 2 after decimal
        if (!Number.isInteger(fpacPriceMin) || !Number.isInteger(fpacPriceMax)) {
            fpacPriceMin = fpacPriceMin.toFixed(2);
            fpacPriceMax = fpacPriceMax.toFixed(2);
        }

        // deciding range or normal
        if (fpacPriceMin !== fpacPriceMax) {
            price.type = 'fpac-range';
            price.fpacPriceMax = fpacPriceMax;
            price.fpacPriceMin = fpacPriceMin;
        } else {
            price.type = 'fpac';
        }

        price.fpac = getPriceFormat(fpacPriceMin, fpacPriceMax, true);
        price.fpacPrice = fpacPriceMin;

        // hidden variables for ab test
        price.fpacCoupon = fprice.fpacCoupon || '';

        price.brand = fprice.brand;
        price.subDivision = fprice.subDivision;
    }

    return price;
};

export default getPrice;
